// 재분석 스토리의 장면 경계(스크롤 진행률 0~1).
// 배경·인물 카드·요약 문구가 같은 지점에서 바뀌어야 하므로 여기서만 정의하고 각 컴포넌트가 가져다 쓴다.
export const REANALYSIS_SCENES = [
  'question',
  'patients',
  'focus',
  'analyzing',
  'diagnosed',
  'summary',
  'conclusion',
] as const;

export const SCENE_START: Record<(typeof REANALYSIS_SCENES)[number], number> = {
  question: 0,
  patients: 0.14,
  focus: 0.32,
  analyzing: 0.49,
  diagnosed: 0.6,
  summary: 0.7,
  conclusion: 0.88,
};

export const SCENE_STARTS = REANALYSIS_SCENES.map(scene => SCENE_START[scene]);

// 마지막 장면 전환(어두운 배경·패널 확장·제목 이동)이 끝나는 지점
export const CONCLUSION_SETTLED = 0.92;
// 요약 제목이 한 글자씩 타이핑되는 구간
export const SUMMARY_TYPING = { start: 0.76, end: 0.88 } as const;
// 사례 보기 링크가 나타나는 지점
export const LINK_VISIBLE = 0.94;
